module.exports = __webpack_public_path__ + "img/display.d21fca4c.png";